import { Outlet } from 'react-router-dom';

/**
 * Layout for /info - no AppLayout (no header/nav).
 */
export function PublicInfoLayout() {
  return (
    <div className="min-h-screen bg-white p-4">
      <Outlet />
    </div>
  );
}

